import { HOUR_IN_MILLISECONDS } from 'domains/occurrence/constants/occurrence'

export const getIntervalInHours = (time: number): number => {
  const interval = new Date().getTime() - time

  const hours = Math.floor(interval / HOUR_IN_MILLISECONDS)

  return hours
}
